import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';
import { TemplateCategory } from '../models/enums/document-template-category.enum';

export const GetDocumentTemplates = createAsyncThunk(
    'timelineTemplates/getDocumentTemplates',
    async (filterParams: TableFilter, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(filterParams);

        try {
            const response = await axios.get(
                `/api/SignTemplates?category=${TemplateCategory.Marketplace}&${queryString}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Document Templates at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch Document Templates');
            }

            return {
                templates: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching Document Templates.',
                'error'
            );
            throw error;
        }
    }
);
